export default __webpack_public_path__ + "static/media/aja.e35aa567.jpg";